import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const SuppliersPage = lazy(() => import("@/features/supplier-master/pages/suppliers"));

export const Route = createFileRoute("/(app)/dashboard/suppliers/")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <SuppliersPage />
    </Suspense>
  ),
});
